import _get from "lodash/get";
export var getMemberProductShoppingActions = function getMemberProductShoppingActions(state) {
  return _get(state, 'identity.productShoppingActions');
};
export var getIsRequestingMemberProductShoppingActions = function getIsRequestingMemberProductShoppingActions(state) {
  return _get(state, 'identity.requests.readProductShoppingActions.hasPendingRequests');
};